"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _material = require("@mui/material/");

var _iconsMaterial = require("@mui/icons-material");

var _formik = require("formik");

var _excluded = ["id", "name", "className", "question", "subQuestionInfo", "questions", "requiredQuestions", "listHeaderId", "rowManagerButtons"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var CHUICollapsibleTable = function CHUICollapsibleTable(_ref) {
  var id = _ref.id,
      name = _ref.name,
      className = _ref.className,
      question = _ref.question,
      subQuestionInfo = _ref.subQuestionInfo,
      questions = _ref.questions,
      requiredQuestions = _ref.requiredQuestions,
      listHeaderId = _ref.listHeaderId,
      rowManagerButtons = _ref.rowManagerButtons,
      otherProps = _objectWithoutProperties(_ref, _excluded);

  var formik = (0, _formik.useFormikContext)();

  var _useState = (0, _react.useState)(0),
      _useState2 = _slicedToArray(_useState, 2),
      open = _useState2[0],
      setOpen = _useState2[1];

  var _useState3 = (0, _react.useState)(["Empty"]),
      _useState4 = _slicedToArray(_useState3, 2),
      listTitles = _useState4[0],
      setListTitles = _useState4[1];

  var handleClick = function handleClick(e, id) {
    setOpen(open == id ? null : id);
  };

  var handleAddRow = function handleAddRow() {
    var len = listTitles.length;
    var currentValues = formik.values[name];
    var currentListTitles = listTitles;

    if (currentListTitles[len - 1] != "Empty") {
      currentListTitles[len] = "Empty";
      currentValues[len] = {};
      setListTitles(currentListTitles);
      formik.setFieldValue(name, currentValues);
    }
  };

  var handleRemoveRow = function handleRemoveRow() {
    var len = listTitles.length;

    if (len != 1) {
      var currentValues = formik.values[name];
      var currentListTitles = listTitles;
      currentValues["errors"] = currentValues["errors"].filter(function (value) {
        return value != (len - 1).toString();
      });
      currentListTitles.pop();
      delete currentValues[len - 1];
      setListTitles(currentListTitles);
      formik.setFieldValue(name, currentValues);
    }
  };

  var handleChange = function handleChange(event, questionId, listId) {
    var currentValues = formik.values[name];
    var currentListTitles = listTitles; //if it doesn't exist set it to an empty json

    currentValues[questionId] = currentValues[questionId] || {};
    currentValues[questionId][listId] = event.target.value;

    if (listId === listHeaderId) {
      currentListTitles[questionId] = event.target.value;
    } //check if there are errors


    var keys = Object.keys(currentValues);
    keys.forEach(function (key) {
      //dont check the errors list
      if (key != "errors") {
        var keyHasError = false;
        requiredQuestions.forEach(function (requiredQuestion) {
          if (currentValues[key][requiredQuestion] === "" || currentValues[key][requiredQuestion] === undefined) {
            if (!currentValues.errors[key]) {
              currentValues.errors.push(key);
            }

            keyHasError = true;
          }
        });

        if (!keyHasError) {
          currentValues.errors = currentValues.errors.filter(function (item) {
            return item !== key;
          });
        }
      }
    });
    setListTitles(currentListTitles);
    formik.setFieldValue(name, currentValues);
  };

  var rowHeaderStyle = function rowHeaderStyle(questionId) {
    return {
      background: formik.values[name]["errors"].includes(questionId.toString()) && formik.errors[name] ? "#cf5757" : "#dfe0e6",
      borderTop: "1px solid #9798a1"
    };
  };

  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_material.Grid, {
    container: true,
    className: className
  }, /*#__PURE__*/_react.default.createElement(_material.Grid, {
    item: true,
    xs: 12
  }, question != null && /*#__PURE__*/_react.default.createElement(_material.Typography, {
    variant: "h6",
    htmlFor: id,
    tabIndex: "0"
  }, question)), /*#__PURE__*/_react.default.createElement(_material.Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/_react.default.createElement(_material.List, {
    sx: {
      width: "90%",
      maxWidth: 560,
      bgcolor: "background.paper"
    },
    component: "nav",
    "aria-labelledby": "row header"
  }, listTitles.map(function (listTitle, i) {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_material.ListItemButton, {
      onClick: function onClick(e) {
        return handleClick(e, i);
      },
      sx: rowHeaderStyle(i)
    }, /*#__PURE__*/_react.default.createElement(_material.ListItemIcon, null, /*#__PURE__*/_react.default.createElement(_iconsMaterial.Medication, null)), /*#__PURE__*/_react.default.createElement(_material.ListItemText, {
      primary: listTitle
    }), open === i ? /*#__PURE__*/_react.default.createElement(_iconsMaterial.ExpandLess, null) : /*#__PURE__*/_react.default.createElement(_iconsMaterial.ExpandMore, null)), /*#__PURE__*/_react.default.createElement(_material.Collapse, {
      in: open === i,
      timeout: "auto",
      unmountOnExit: true
    }, /*#__PURE__*/_react.default.createElement(_material.List, {
      component: "paper"
    }, /*#__PURE__*/_react.default.createElement(_material.Box, {
      component: "form",
      sx: {
        "& > :not(style)": {
          m: 1,
          width: {
            xs: "100%",
            sm: "90%"
          }
        }
      },
      noValidate: true,
      autoComplete: "off"
    }, questions.map(function (question, j) {
      return question.type === "text" ? /*#__PURE__*/_react.default.createElement(_material.TextField, {
        key: j,
        label: question.label,
        variant: "outlined",
        onChange: function onChange(e) {
          return handleChange(e, i, question.id);
        },
        value: formik.values[name][i] ? formik.values[name][i][question.id] || "" : ""
      }) : question.type === "radioButton" ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, question.label != null && /*#__PURE__*/_react.default.createElement(_material.Typography, {
        sx: {
          padding: "20px 0 0 0"
        },
        variant: "h6",
        htmlFor: id,
        tabIndex: "0"
      }, question.label), /*#__PURE__*/_react.default.createElement(_material.RadioGroup, {
        name: "RadioButton",
        value: formik.values[name][i] ? formik.values[name][i][question.id] || "" : "",
        onChange: function onChange(e) {
          return handleChange(e, i, question.id);
        }
      }, question.options.map(function (choice) {
        return /*#__PURE__*/_react.default.createElement(_material.FormControlLabel, {
          value: choice["value"],
          control: /*#__PURE__*/_react.default.createElement(_material.Radio, {
            "aria-label": "radio button",
            tabIndex: "0"
          }),
          label: choice["label"],
          tabIndex: "0"
        });
      }))) : null;
    })), /*#__PURE__*/_react.default.createElement(_material.Divider, null))));
  }))), /*#__PURE__*/_react.default.createElement(_material.Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/_react.default.createElement(_material.Box, {
    sx: {
      width: "90%",
      maxWidth: 560,
      display: "flex",
      justifyContent: "space-evenly",
      padding: "20px 0 0 0"
    }
  }, /*#__PURE__*/_react.default.createElement(_material.Button, {
    sx: {
      fontSize: "16px",
      color: "#fff",
      padding: "5px 20px",
      backgroundColor: "#27ae60",
      ":hover": {
        backgroundColor: "#5AE193"
      }
    },
    onClick: handleAddRow
  }, rowManagerButtons["add"]), /*#__PURE__*/_react.default.createElement(_material.Button, {
    sx: {
      fontSize: "16px",
      color: "#fff",
      padding: "5px 20px",
      backgroundColor: "#C0392B",
      ":hover": {
        backgroundColor: "#F36C5E"
      }
    },
    onClick: handleRemoveRow
  }, rowManagerButtons["remove"])))), formik.errors[name] ? /*#__PURE__*/_react.default.createElement(_material.FormHelperText, {
    error: true,
    sx: {
      color: "#f44336"
    }
  }, formik.errors[name] ? formik.errors[name].errors : null) : null);
};

var _default = CHUICollapsibleTable;
exports.default = _default;